export default "__VITE_ASSET__DC7qcXxi__"